/* ==========================================================================
   crocs-banner-video @ 1.0.0 — reproduccion de los videos del slider de banners

   El markup ya sale correcto: video_tag emite autoplay, loop, muted y
   playsinline --este ultimo lo pone Shopify siempre, aunque no se pida-- que es
   justo lo que iOS exige para reproducir sin gesto del usuario.

   Lo que falla es el momento. Safari en iOS solo arranca un video que este
   visible al momento de intentarlo, y en este slider hay dos motivos para que no
   lo este cuando la pagina carga:

   - hasta que Flickity inicializa, theme.css deja los slides que no son el
     primero en visibility: hidden;
   - cada slide emite la version desktop y la mobile, y la que no corresponde al
     ancho de pantalla queda en display: none.

   Cuando el slide por fin se vuelve visible, el intento de autoplay ya fracaso y
   nadie lo vuelve a pedir: ni el slider de Broadcast ni crocs-carousel.js tocan
   los videos.

   Aca se pide play al video que esta a la vista y se pausa el resto. Lo segundo
   no es solo prolijidad: iOS limita cuantos videos puede tener sonando a la vez,
   y esta seccion emite dos por slide.
   ========================================================================== */

(function () {
  'use strict';

  var ROOT = '[data-crocs-banner-video]';
  var SLIDE = '.slideshow__slide';

  function onStage(video) {
    /* display: none deja al elemento sin rects; visibility: hidden no, pero
       hereda, asi que el estilo computado del propio video ya delata a un
       ancestro oculto. Entre los dos se cubren los dos casos de arriba. */
    if (!video.getClientRects().length) return false;
    if (window.getComputedStyle(video).visibility === 'hidden') return false;

    /* Con transicion de fundido los slides que no estan al frente siguen
       ocupando lugar, asi que la visibilidad no alcanza para descartarlos. */
    var slide = video.closest ? video.closest(SLIDE) : null;
    if (slide && !slide.classList.contains('is-selected')) return false;

    return true;
  }

  function sync(root) {
    var videos = root.querySelectorAll('video');
    var n;

    for (n = 0; n < videos.length; n++) {
      var video = videos[n];

      if (!onStage(video)) {
        if (!video.paused) video.pause();
        continue;
      }

      /* Cuando el play lo pide un script, Safari mira las propiedades y no los
         atributos del markup. */
      video.muted = true;
      video.playsInline = true;

      var played = video.play();
      /* La promesa se rechaza si el navegador decide no reproducir --modo de bajo
         consumo, por ejemplo-- y sin catch queda un error suelto en consola. */
      if (played && played.catch) played.catch(function () {});
    }
  }

  function setup(root) {
    sync(root);

    /* El slider marca el slide al frente con is-selected, y al inicializar le
       agrega flickity-enabled a la pista. Observar el atributo class cubre los
       dos momentos sin depender de la API de Flickity, que esta minificada
       dentro de theme.js. */
    var observer = new MutationObserver(function () {
      sync(root);
    });

    observer.observe(root, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    /* El cambio de ancho intercambia cual de las dos capas esta visible. */
    var timer = null;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { sync(root); }, 200);
    });

    /* Ultimo recurso: si el navegador nego el autoplay, el primer gesto del
       usuario en la pagina habilita la reproduccion. Es lo que rescata al modo
       de bajo consumo de iOS, que bloquea el autoplay sin excepcion. */
    function onFirstGesture() {
      sync(root);
      document.removeEventListener('touchstart', onFirstGesture);
      document.removeEventListener('click', onFirstGesture);
    }

    document.addEventListener('touchstart', onFirstGesture, { passive: true });
    document.addEventListener('click', onFirstGesture);
  }

  function init() {
    var roots = document.querySelectorAll(ROOT);
    var n;

    for (n = 0; n < roots.length; n++) {
      if (roots[n].dataset.crocsVideoReady) continue;
      roots[n].dataset.crocsVideoReady = 'true';
      setup(roots[n]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
